module.exports = __webpack_public_path__ + "img/otp.372fde0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/otp.png
// module id = MGjC
// module chunks = 39 44